﻿export default class PhoneNumberViewModel {
    public purchaseId: number = 0;
    public countryCode: string = '';
    public phoneNumber: string = '';

}